import * as React from "react"
import {CheckboxProps, Form, InputOnChangeData} from "semantic-ui-react"
import {needPeopleMover} from "./PassengerFields"
import {adjustPassengerCount, MapState, validPassengerCount} from "./BookingDetails"

interface VehicleState {
  wantPeopleMover: boolean
  passengerCount: string
}

interface VehicleWidgetProps {
  state: VehicleState
  mapState: MapState<VehicleState> | null
  disabled: boolean
}

export function VehicleWidget(props: VehicleWidgetProps) {
  const {
    state: {passengerCount},
    mapState,
    disabled,
  } = props
  return (
    <Form.Group>
      <Form.Field>
        <label>Total passengers</label>
        {!mapState ? (
          passengerCount
        ) : (
          <Form.Input
            disabled={disabled}
            type="number"
            min="1"
            step="1"
            pattern="\d*"
            error={!validPassengerCount(passengerCount)}
            value={passengerCount}
            onChange={(e, field: InputOnChangeData) => {
              mapState((state) => ({...state, passengerCount: field.value}))
            }}
          />
        )}
      </Form.Field>
      <PeopleMoverField {...props} />
    </Form.Group>
  )
}

export function PeopleMoverField(props: {
  state: VehicleState
  mapState: MapState<VehicleState> | null
  disabled: boolean
}) {
  const {
    disabled,
    mapState,
    state: {wantPeopleMover, passengerCount},
  } = props
  const needAPeopleMover = needPeopleMover(adjustPassengerCount(passengerCount))
  return (
    <Form.Field>
      {!mapState && <label>People mover required</label>}
      {mapState ? (
        <Form.Checkbox
          label="People mover required"
          checked={wantPeopleMover || needAPeopleMover}
          disabled={disabled || needAPeopleMover}
          onChange={(e, checkbox: CheckboxProps) => {
            mapState((state) => ({...state, wantPeopleMover: checkbox.checked || false}))
          }}
        />
      ) : wantPeopleMover ? (
        "Yes"
      ) : (
        "No"
      )}
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./src/components/VehicleWidget.tsx